export default function Promos() {
  const promos = [
    {
      title: 'Paket Hemat CCTV',
      icon: 'ri-webcam-line',
      color: 'from-blue-500 to-blue-600',
      originalPrice: '2.500.000',
      discountPrice: '2.100.000',
      discount: '16%',
      features: [
        '4 Kamera CCTV 2MP',
        'DVR 4 Channel + HDD 500GB',
        'Instalasi & Setting Lengkap',
        'Garansi 1 Tahun',
        'Gratis Maintenance 3 Bulan'
      ],
      badge: 'Paling Laris'
    },
    {
      title: 'Paket Pernikahan Lengkap',
      icon: 'ri-heart-line',
      color: 'from-pink-500 to-pink-600',
      originalPrice: '850.000',
      discountPrice: '650.000',
      discount: '24%',
      features: [
        'Undangan Digital Website Premium',
        'Desain Banner & Spanduk',
        'Cetak 100 Foto 4R + Frame',
        'QR Code Custom untuk Tamu',
        'Revisi Unlimited'
      ],
      badge: 'Best Deal'
    },
    {
      title: 'Paket Upgrade Laptop',
      icon: 'ri-computer-line',
      color: 'from-purple-500 to-purple-600',
      originalPrice: '1.200.000',
      discountPrice: '950.000',
      discount: '21%',
      features: [
        'Upgrade SSD 256GB',
        'Upgrade RAM 8GB',
        'Install Ulang Windows 11',
        'Install Office & Software',
        'Garansi 3 Bulan'
      ],
      badge: 'Hemat'
    },
    {
      title: 'Paket UMKM Starter',
      icon: 'ri-store-line',
      color: 'from-orange-500 to-orange-600',
      originalPrice: '750.000',
      discountPrice: '550.000',
      discount: '27%',
      features: [
        'Desain Logo Profesional',
        'Cetak Banner 2x1 meter',
        'Cetak Stiker Label 200 pcs',
        'Kartu Nama 100 pcs',
        'Simple Website UMKM'
      ],
      badge: 'Promo Spesial'
    },
    {
      title: 'Paket Masjid Digital',
      icon: 'ri-building-line',
      color: 'from-green-500 to-green-600',
      originalPrice: '4.500.000',
      discountPrice: '3.800.000',
      discount: '16%',
      features: [
        'Jam Digital Masjid LED Besar',
        'Running Text LED 1 Meter',
        'Instalasi & Setting Otomatis',
        'Garansi 2 Tahun',
        'Gratis Maintenance 6 Bulan'
      ],
      badge: 'Paket Premium'
    },
    {
      title: 'Paket Cetak Foto Keluarga',
      icon: 'ri-image-line',
      color: 'from-yellow-500 to-yellow-600',
      originalPrice: '350.000',
      discountPrice: '250.000',
      discount: '29%',
      features: [
        'Cetak 50 Foto 4R',
        'Cetak 10 Foto 5R',
        'Cetak 5 Foto 8R + Frame',
        'Restorasi 5 Foto Lama',
        'Gratis Soft File HD'
      ],
      badge: 'Hemat Banget'
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-[#FF8A00] font-semibold text-sm uppercase tracking-wider bg-orange-50 px-4 py-2 rounded-full">
              Promo Spesial
            </span>
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-[#0B1F3B] mb-4">
            Paket Bundling Hemat
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Dapatkan harga spesial dengan paket bundling kami. Hemat lebih banyak!
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {promos.map((promo, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl shadow-lg hover:shadow-2xl transition-all duration-300 border border-gray-100 hover:border-[#FF8A00] overflow-hidden hover:-translate-y-2"
            >
              <div className="relative">
                <div className={`h-32 bg-gradient-to-br ${promo.color} flex items-center justify-center relative overflow-hidden`}>
                  <div className="absolute inset-0 bg-black/10"></div>
                  <i className={`${promo.icon} text-7xl text-white/90 relative z-10`}></i>
                  <div className="absolute top-4 right-4 bg-white text-[#0B1F3B] px-3 py-1 rounded-full text-xs font-bold shadow-lg">
                    {promo.badge}
                  </div>
                </div>
                <div className="absolute -bottom-6 left-1/2 transform -translate-x-1/2">
                  <div className="bg-gradient-to-r from-red-500 to-red-600 text-white px-6 py-2 rounded-full shadow-lg">
                    <span className="text-sm font-bold">Hemat {promo.discount}</span>
                  </div>
                </div>
              </div>

              <div className="p-8 pt-10">
                <h3 className="text-2xl font-bold text-[#0B1F3B] mb-4 text-center">
                  {promo.title}
                </h3>

                <div className="text-center mb-6">
                  <div className="text-gray-400 line-through text-sm mb-1">
                    Rp {promo.originalPrice}
                  </div>
                  <div className="text-3xl font-bold text-[#FF8A00]">
                    Rp {promo.discountPrice}
                  </div>
                </div>

                <div className="space-y-3 mb-6">
                  {promo.features.map((feature, idx) => (
                    <div key={idx} className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-[#FF8A00] text-xl mt-0.5 flex-shrink-0"></i>
                      <span className="text-gray-700 text-sm leading-relaxed">{feature}</span>
                    </div>
                  ))}
                </div>

                <a
                  href="https://wa.me/6285868360910"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block w-full bg-gradient-to-r from-[#0B1F3B] to-[#0d2847] text-white py-3 rounded-xl font-semibold hover:shadow-lg transition-all duration-300 text-center group-hover:scale-105 whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  Pesan Sekarang
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-[#FF8A00] to-orange-600 rounded-3xl p-8 md:p-12 text-center shadow-2xl">
          <div className="max-w-3xl mx-auto">
            <div className="w-20 h-20 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-6">
              <i className="ri-gift-line text-5xl text-white"></i>
            </div>
            <h3 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Promo Khusus Pelanggan Setia
            </h3>
            <p className="text-white/90 text-lg mb-8 leading-relaxed">
              Dapatkan diskon tambahan <strong>10%</strong> untuk pembelian paket kedua dan seterusnya. 
              Ajak teman atau keluarga dan dapatkan <strong>voucher gratis</strong> senilai Rp 50.000!
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <a
                href="https://wa.me/6285868360910"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-3 bg-white text-[#FF8A00] px-8 py-4 rounded-xl font-semibold hover:bg-gray-100 transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line text-2xl"></i>
                Tanya Promo Terbaru
              </a>
              <button
                onClick={() => document.querySelector('#vapi-widget-floating-button')?.click()}
                className="inline-flex items-center gap-3 bg-[#0B1F3B] text-white px-8 py-4 rounded-xl font-semibold hover:bg-[#0d2847] transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-customer-service-2-line text-2xl"></i>
                Chat dengan Asisten AI
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
